module.exports = __webpack_public_path__ + "media/src/public/img/phone_hand-878ef6e0c7cbcc3911dac884a72b16b8.svg";